import React, { useEffect, useRef, useState } from "react";

const TestimonialsSection = () => {
  const scrollRef = useRef(null);
  const pauseTimerRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const SCROLL_STEP = 320;
  const testimonials = [
    {
      id: 1,
      name: "Jackie",
      role: "Marketing Partner",
      image:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
      description:
        "Great opportunity for those who are not familiar with cryptocurrency to learn and grow in a developing ecosystem.",
    },
    {
      id: 2,
      name: "Marianna",
      role: "Marketing Partner",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
      description:
        "Cryptocurrency is the future of financing, there's exponential growth with the right vision.",
    },
    {
      id: 3,
      name: "Mike Johnson",
      role: "Marketing Partner",
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop",
      description:
        "Marketplace platform is the difference maker on how the coin will be used and deploy.",
    },
    {
      id: 4,
      name: "Jesus",
      role: "Marketing Partner",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
      description:
        "Imagine Amazon having its own coin and using it to shop on Amazon, that's what we are doing here with synergy marketplace.",
    },
  ];

  useEffect(() => {
    return () => {
      if (pauseTimerRef.current) {
        clearTimeout(pauseTimerRef.current);
      }
    };
  }, []);

  const handleArrowClick = (direction) => {
    if (!scrollRef.current) return;
    setIsPaused(true);
    scrollRef.current.scrollBy({
      left: direction * SCROLL_STEP,
      behavior: "smooth",
    });
    if (pauseTimerRef.current) {
      clearTimeout(pauseTimerRef.current);
    }
    pauseTimerRef.current = setTimeout(() => {
      setIsPaused(false);
    }, 2000);
  };

  return (
    <section className="bg-black py-16">
      <style>{`
        @keyframes testimonial-scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .testimonial-slider {
          display: flex;
          animation: testimonial-scroll 25s linear infinite;
          width: max-content;
          will-change: transform;
        }

        .testimonial-slider:hover {
          animation-play-state: paused;
        }

        .testimonial-slider.paused {
          animation-play-state: paused;
        }

        .testimonial-scroll {
          overflow-x: auto;
          scrollbar-width: none;
        }

        .testimonial-scroll::-webkit-scrollbar {
          display: none;
        }
      `}</style>

      <div ref={scrollRef} className="testimonial-scroll w-full">
        <div className={`testimonial-slider gap-4 sm:gap-6 ${isPaused ? "paused" : ""}`}>
          {[...testimonials, ...testimonials].map((testimonial, index) => (
            <div
              key={`testimonial-${index}`}
              className="flex-shrink-0 w-[60vw] sm:w-[280px] md:w-[340px] lg:w-[400px]"
            >
              <div className="relative rounded-2xl p-6 shadow-xl border border-gray-700 hover:border-purple-500 transition-all duration-300 bg-gradient-to-br from-gray-900/80 to-gray-800/60 h-full">
                <div className="flex items-center mb-4">
                  <div className="flex-shrink-0 mr-4">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-12 h-12 rounded-full object-cover border-2 border-purple-500"
                    />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">
                      {testimonial.name}
                    </h3>
                    <p className="text-sm text-gray-400">{testimonial.role}</p>
                  </div>
                </div>
                <p className="text-gray-300 leading-relaxed">
                  "{testimonial.description}"
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mx-auto flex w-full max-w-6xl items-center justify-center gap-2 px-4 pt-6 sm:px-6">
        <button
          type="button"
          onClick={() => handleArrowClick(-1)}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 bg-white/5 text-white/80 transition hover:border-white/30 hover:bg-white/10 hover:text-white"
          aria-label="Scroll left"
        >
          &#8592;
        </button>
        <button
          type="button"
          onClick={() => handleArrowClick(1)}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 bg-white/5 text-white/80 transition hover:border-white/30 hover:bg-white/10 hover:text-white"
          aria-label="Scroll right"
        >
          &#8594;
        </button>
      </div>
    </section>
  );
};

export default TestimonialsSection;
